// R54-1 (review 22-Oct) — the "Pre-fill from 203(a)" button of a walkthrough cycle on an engagement that was pre-filled
// before (the auditor decides; nothing is added on page open). EN + AR.
export const I18N_R54 = {
  en: {
    r54: {
      prefill203a: "Pre-fill from 203(a)",
      prefill203aHint: "Adds this cycle's controls listed in 203(a) as walkthrough rows (once). Rows already in other cycles stay as they are.",
      prefill203aDone: "{n} row(s) added from 203(a)",
      prefill203aNone: "Nothing to add: this cycle was already pre-filled from 203(a)",
    },
  },
  ar: {
    r54: {
      prefill203a: "تعبئة مسبقة من ⁨203(a)⁩",
      prefill203aHint: "يضيف ضوابط هذه الدورة المدرجة في ⁨203(a)⁩ كصفوف اختبار تتبع (مرة واحدة). تبقى الصفوف الموجودة في الدورات الأخرى كما هي.",
      prefill203aDone: "تمت إضافة {n} صف/صفوف من ⁨203(a)⁩",
      prefill203aNone: "لا شيء لإضافته: سبقت تعبئة هذه الدورة من ⁨203(a)⁩",
    },
  },
};

export default I18N_R54;
